
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Briefcase, MapPin, User, Zap, Search } from 'lucide-react';
import { carrerList } from './CareerList';
import diversity from "../../../Assets/diversity.png";
import { useScrollAnimation } from "../../../utils/Utils";
import Image from "../../../Assets/carrer/carrer.png";
import CarrerPhotoCollab from "./CarrerPhotoCollab";
const Career = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedJobType, setSelectedJobType] = useState('All');
  const [selectedLocation, setSelectedLocation] = useState('All');
  const [sortBy, setSortBy] = useState('recent');
  const [filteredJobs, setFilteredJobs] = useState(carrerList);

  // Get unique job types and locations for filter options
  const jobTypes = ['All', ...new Set(carrerList.map(job => job.jobType))];
  const locations = ['All', ...new Set(carrerList.map(job => job.location))];

  useEffect(() => {
    let results = carrerList.filter(job => {
      const matchesSearch = job.position.toLowerCase().includes(searchQuery.toLowerCase()) ||
        job.description.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesJobType = selectedJobType === 'All' || job.jobType === selectedJobType;
      const matchesLocation = selectedLocation === 'All' || job.location === selectedLocation;
      return matchesSearch && matchesJobType && matchesLocation;
    });

    // Sorting logic
    if (sortBy === 'recent') {
      results.sort((a, b) => new Date(b.datePosted) - new Date(a.datePosted));
    } else if (sortBy === 'name') {
      results.sort((a, b) => a.position.localeCompare(b.position));
    }

    setFilteredJobs(results);
  }, [searchQuery, selectedJobType, selectedLocation, sortBy]);

  const handleApply = (job) => {
    navigate(`/career/position_description/${job.position}`, {
      state: { job },
    });
  };
  useScrollAnimation();
  return (
    <div className="bg-[#fff]">
       <img
        src={Image}
        alt="Career Banner"
        className="w-full h-full object-cover "
      />
      {/* Banner Section - Remains same as before */}
        {/* <CarrerPhotoCollab/> */}
      {/* Filters Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 rounded-xl shadow-md">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <div className="relative flex items-center">
            <Search className="absolute left-3 text-gray-400 h-5 w-5" />
            <input
              type="text"
              placeholder="Search positions..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 pr-4 py-2 w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <select
            value={selectedJobType}
            onChange={(e) => setSelectedJobType(e.target.value)}
            className="px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {jobTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>

          <select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
            className="px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {locations.map(location => (
              <option key={location} value={location}>{location}</option>
            ))}
          </select>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="recent">Newest First</option>
            <option value="name">Sort by Name</option>
          </select>
        </div>

        {/* Jobs Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredJobs.map((job, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <h3 className="text-xl font-semibold text-[#000080]">
                    {job.position}
                  </h3>
                </div>

                <div className="space-y-3 mb-4">
                  <div className="flex items-center text-gray-600">
                    <Briefcase className="mr-2 text-[#4169E1] w-5 h-5" />
                    <span>{job.jobType}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <MapPin className="mr-2 text-[#4169E1] w-5 h-5" />
                    <span>{job.location}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <User className="mr-2 text-[#4169E1] w-5 h-5" />
                    <span>{job.experience}</span>
                  </div>
                </div>

                <p className="text-md text-gray-800 mb-3 text-[#1E3A8A]">Job Description:</p>
                <p className="text-gray-700 text-md line-clamp-3">
                  {job.description}
                </p>

                <button
                  onClick={() => handleApply(job)}
                  style={{ backgroundColor: '#1E3A8A' }}
                  className="mt-5 w-full bg-blue-600 text-white hover:bg-blue-700 py-2 px-4 rounded-lg flex items-center justify-center transition-colors"
                >
                  <Zap className="mr-2 w-5 h-5" />
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* No Results Message */}
        {filteredJobs.length === 0 && (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600 font-bold ml-10">No positions found matching your criteria</p>
            <button
              onClick={() => {
                setSearchQuery('');
                setSelectedJobType('All');
                setSelectedLocation('All');
              }}
              className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>

      {/* Diversity Section - Remains same as before */}

       
      <section className="bg-darkblue py-10">
         <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-7 xl:mx-40 mx-3 md:mx-10">
           {/* Card 1 */}
           <div className="flex flex-col justify-between max-w-sm bg-[#092f4f] rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
             <div className="px-5 pt-5 flex-grow">
               <h5 className="mb-2 text-xl font-bold tracking-tight text-[#ffd626] dark:text-white animate-up">
                 Diversity, Equity and Inclusion Initiative - Kapil
               </h5>
               <p className="mb-3 font-normal text-white dark:text-gray-400 animate-up">
                 In an endeavor to become a workplace of choice among people, we
                 are striving to create an atmosphere where multiple voices are
                 heard, and their opinions are valued and considered..
               </p>
             </div>
          
               <img
                className="rounded-b-lg w-full h-72 object-cover"
                src={diversity}
                alt="diversity"
              />
           
          </div>

          {/* Card 2 */}
          <div className="flex flex-col justify-between max-w-sm bg-[#092f4f] rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="px-5 pt-5 flex-grow">
              <h5 className="mb-2 text-xl font-bold tracking-tight text-[#ffd626] dark:text-white animate-up">
                Balancing the Gender Mix
              </h5>
              <p className="mb-3 font-normal text-white dark:text-gray-400 animate-up">
                Referral Recruitment Drive – Exclusively for women to upskill or
                restart their career!
              </p>
            </div>
     
              <img
                className="rounded-b-lg w-full h-72 object-cover"
                src={diversity}
                alt="diversity"
              />
        
          </div>

          {/* Card 3 */}
          <div className="flex flex-col justify-between max-w-sm bg-[#092f4f] rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="px-5 pt-5 flex-grow">
              <h5 className="mb-2 text-xl font-bold tracking-tight text-[#ffd626] dark:text-white animate-up">
               Community Outreach and Support - KCS Tech
              </h5>
              <p className="mb-3 font-normal text-white dark:text-gray-400 animate-up">
                KCS is committed to making a positive impact beyond our workplace. We actively engage in community outreach initiatives that support underrepresented groups
              </p>
            </div>
           
              <img
                className="rounded-b-lg w-full h-72 object-cover"
                src={diversity}
                alt="diversity"
              />
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default Career;